import moment from 'moment-timezone';

export const HISTORICAL_METRIC_COLOR = {
  NEW: '#77DD77',
  REACTIVATIONS: '#AEC6CF',
  UPGRADES: '#FDFD96',
  DOWNGRADES: '#FFB347',
  VOLUNTARY_CHURNS: '#FF6961',
  DELINQUENT_CHURNS: '#CBAACB',
  EXISTING: '#B2DFEE',
  MRR: '#004C6D',
  TOTAL: '#004C6D',
};

export function getSortedHistoricalMetricsData(results) {
  return Object.entries(results).sort((a, b) => {
    const dateA = moment(a[0], 'MMMM YYYY');
    const dateB = moment(b[0], 'MMMM YYYY');
    return dateA.isBefore(dateB) ? -1 : 1;
  });
}


export const START_DATE_DEFAULT = moment()
  .subtract(1, 'year')
  .startOf('month');
export const MAX_DATE_DEFAULT = moment()
  .subtract(1, 'month')
  .endOf('month');
